<template>
  <div class="right-side-nav">
    <div class="div-block-165">
      <div class="div-block-11">
        <div class="div-block-5">
          <div class="div-block-6">
            <img
              v-if="'customerDisplayPicture' in customerInfo"
              class="image-profile-pic"
              :src="customerInfo.customerDisplayPicture"
            />
            <div class="text-block-8" v-else>
              {{ userInfo.customerFirstName.charAt(0)
              }}{{ userInfo.customerLastName.charAt(0) }}
            </div>
          </div>
          <div>
            <div class="text-block-6">
              {{ userInfo.customerFirstName }} {{ userInfo.customerLastName }}
            </div>

            <div class="text-block-7">
              <div @click="goToProfile" class="link-2">View profile</div>
            </div>
          </div>
        </div>
      </div>
      <!--      <div class="suggested-pro">-->
      <!--        <div>-->
      <!--          <div class="div-block-12"><img src="@/assets/timeslot-images/explore.png" loading="lazy" width="108" alt="" class="image-3">-->
      <!--            <div class="text-block-9">Suggested Professionals</div>-->
      <!--            <div class="text-block-10">Based on your expertise, we feel you may be interested in these professionals</div>-->
      <!--            <router-link to="/discover-professionals" class="timeslot-button w-button">Explore</router-link>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="suggested-pro">-->
      <!--        <div>-->
      <!--          <div class="div-block-12-copy">-->
      <!--            <div class="text-block-9-copy">My Connections</div>-->
      <!--            &lt;!&ndash;            <router-link&ndash;&gt;-->
      <!--            &lt;!&ndash;              to="/professional-profile"&ndash;&gt;-->
      <!--            &lt;!&ndash;              class="div-block-99 w-inline-block"&ndash;&gt;-->
      <!--            &lt;!&ndash;            >&ndash;&gt;-->
      <!--            &lt;!&ndash;              <div class="div-block-100">&ndash;&gt;-->
      <!--            &lt;!&ndash;                <img&ndash;&gt;-->
      <!--            &lt;!&ndash;                  src="@/assets/timeslot-images/profile-picture.png"&ndash;&gt;-->
      <!--            &lt;!&ndash;                  loading="lazy"&ndash;&gt;-->
      <!--            &lt;!&ndash;                  width="45"&ndash;&gt;-->
      <!--            &lt;!&ndash;                  alt=""&ndash;&gt;-->
      <!--            &lt;!&ndash;                  class="image-23"&ndash;&gt;-->
      <!--            &lt;!&ndash;                />&ndash;&gt;-->
      <!--            &lt;!&ndash;                <div>&ndash;&gt;-->
      <!--            &lt;!&ndash;                  <div class="text-block-79">Idris Yusuf</div>&ndash;&gt;-->
      <!--            &lt;!&ndash;                  <div class="text-block-80">Product Designer</div>&ndash;&gt;-->
      <!--            &lt;!&ndash;                </div>&ndash;&gt;-->
      <!--            &lt;!&ndash;              </div>&ndash;&gt;-->
      <!--            &lt;!&ndash;              <div>&ndash;&gt;-->
      <!--            &lt;!&ndash;                <img&ndash;&gt;-->
      <!--            &lt;!&ndash;                  src="@/assets/timeslot-images/back.svg"&ndash;&gt;-->
      <!--            &lt;!&ndash;                  loading="lazy"&ndash;&gt;-->
      <!--            &lt;!&ndash;                  alt=""&ndash;&gt;-->
      <!--            &lt;!&ndash;                />&ndash;&gt;-->
      <!--            &lt;!&ndash;              </div>&ndash;&gt;-->
      <!--            &lt;!&ndash;            </router-link>&ndash;&gt;-->
      <!--            &lt;!&ndash;            <router-link&ndash;&gt;-->
      <!--            &lt;!&ndash;              to="/professional-profile"&ndash;&gt;-->
      <!--            &lt;!&ndash;              class="div-block-99 w-inline-block"&ndash;&gt;-->
      <!--            &lt;!&ndash;            >&ndash;&gt;-->
      <!--            &lt;!&ndash;              <div class="div-block-100">&ndash;&gt;-->
      <!--            &lt;!&ndash;                <img&ndash;&gt;-->
      <!--            &lt;!&ndash;                  src="@/assets/timeslot-images/profile-picture.png"&ndash;&gt;-->
      <!--            &lt;!&ndash;                  loading="lazy"&ndash;&gt;-->
      <!--            &lt;!&ndash;                  width="45"&ndash;&gt;-->
      <!--            &lt;!&ndash;                  alt=""&ndash;&gt;-->
      <!--            &lt;!&ndash;                  class="image-23"&ndash;&gt;-->
      <!--            &lt;!&ndash;                />&ndash;&gt;-->
      <!--            &lt;!&ndash;                <div>&ndash;&gt;-->
      <!--            &lt;!&ndash;                  <div class="text-block-79">Idris Yusuf</div>&ndash;&gt;-->
      <!--            &lt;!&ndash;                  <div class="text-block-80">Product Designer</div>&ndash;&gt;-->
      <!--            &lt;!&ndash;                </div>&ndash;&gt;-->
      <!--            &lt;!&ndash;              </div>&ndash;&gt;-->
      <!--            &lt;!&ndash;              <div>&ndash;&gt;-->
      <!--            &lt;!&ndash;                <img&ndash;&gt;-->
      <!--            &lt;!&ndash;                  src="@/assets/timeslot-images/back.svg"&ndash;&gt;-->
      <!--            &lt;!&ndash;                  loading="lazy"&ndash;&gt;-->
      <!--            &lt;!&ndash;                  alt=""&ndash;&gt;-->
      <!--            &lt;!&ndash;                />&ndash;&gt;-->
      <!--            &lt;!&ndash;              </div>&ndash;&gt;-->
      <!--            &lt;!&ndash;            </router-link>&ndash;&gt;-->
      <!--            &lt;!&ndash;            <router-link&ndash;&gt;-->
      <!--            &lt;!&ndash;              to="/professional-profile"&ndash;&gt;-->
      <!--            &lt;!&ndash;              class="div-block-99 w-inline-block"&ndash;&gt;-->
      <!--            &lt;!&ndash;            >&ndash;&gt;-->
      <!--            &lt;!&ndash;              <div class="div-block-100">&ndash;&gt;-->
      <!--            &lt;!&ndash;                <img&ndash;&gt;-->
      <!--            &lt;!&ndash;                  src="@/assets/timeslot-images/profile-picture.png"&ndash;&gt;-->
      <!--            &lt;!&ndash;                  loading="lazy"&ndash;&gt;-->
      <!--            &lt;!&ndash;                  width="45"&ndash;&gt;-->
      <!--            &lt;!&ndash;                  alt=""&ndash;&gt;-->
      <!--            &lt;!&ndash;                  class="image-23"&ndash;&gt;-->
      <!--            &lt;!&ndash;                />&ndash;&gt;-->
      <!--            &lt;!&ndash;                <div>&ndash;&gt;-->
      <!--            &lt;!&ndash;                  <div class="text-block-79">Idris Yusuf</div>&ndash;&gt;-->
      <!--            &lt;!&ndash;                  <div class="text-block-80">Product Designer</div>&ndash;&gt;-->
      <!--            &lt;!&ndash;                </div>&ndash;&gt;-->
      <!--            &lt;!&ndash;              </div>&ndash;&gt;-->
      <!--            &lt;!&ndash;              <div>&ndash;&gt;-->
      <!--            &lt;!&ndash;                <img&ndash;&gt;-->
      <!--            &lt;!&ndash;                  src="@/assets/timeslot-images/back.svg"&ndash;&gt;-->
      <!--            &lt;!&ndash;                  loading="lazy"&ndash;&gt;-->
      <!--            &lt;!&ndash;                  alt=""&ndash;&gt;-->
      <!--            &lt;!&ndash;                />&ndash;&gt;-->
      <!--            &lt;!&ndash;              </div>&ndash;&gt;-->
      <!--            &lt;!&ndash;            </router-link>&ndash;&gt;-->
      <!--            <div class="prof-mid">-->
      <!--              <img-->
      <!--                src="@/assets/timeslot-images/explore.png"-->
      <!--                loading="lazy"-->
      <!--                width="108"-->
      <!--                alt=""-->
      <!--                class="image-3"-->
      <!--              />-->
      <!--              <div style="text-align: center; margin-top: 0px;">-->
      <!--                You have no connections-->
      <!--              </div>-->
      <!--            </div>-->

      <!--            <router-link-->
      <!--              to="/discover-professionals"-->
      <!--              class="link-block-10 w-inline-block"-->
      <!--            >-->
      <!--              <div class="explore-professionals_button">Connect</div>-->
      <!--            </router-link>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <div class="stats-bar">
        <div class="stats-grid">
          <div>
            <p class="text-block-83 ">{{ bookingsTotal }}</p>
            <p class="centralized">Bookings</p>
          </div>
          <div>
            <p class="text-block-83 earning ">0</p>
            <p class="centralized">Earnings</p>
          </div>
          <div>
            <p class="text-block-83 review-color ">{{ reviews.length }}</p>
            <p class="centralized">Reviews</p>
          </div>
          <div>
            <p class="text-block-83 minutes ">{{ minutesTotal }}</p>
            <p class="centralized">Minutes</p>
          </div>
        </div>
      </div>

      <!--//      <div>-->
      <!--//        <div>-->
      <!--          <div class="div-block-12"><img src="@/assets/timeslot-images/Group-36721.png" loading="lazy" width="108" alt="" class="image-3">-->
      <!--            <div class="text-block-9">Become a Professional</div>-->
      <!--            <div class="text-block-10">Based on your expertise, we feel you may be interested in these professionals</div>-->
      <!--            <a data-w-id="7a736092-9bb6-5ac0-2e0b-139e7451ea07" href="#" class="timeslot-button w-button">Get started</a>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";

export default {
  name: "ProfRightSideMenu",
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      profBookingInfo: state => state.booking.profBookingInfo,
      profInfo: state => state.professional.professionalInfo,
      availableDates: state => state.availability.availableDates,
      reviews: state => state.professional.reviews,
      professionalId: state => state.professional.professionalId,
      customerInfo: state => state.customer.customerInfo,
      customerToProfessionalId: state =>
        state.professional.customerToProfessionalId
    }),
    bookingsTotal() {
      let upcoming = this.profBookingInfo.filter(
        item => item.bookingStatus === "UPCOMING"
      );
      let upLength = upcoming.length;
      let past = this.profBookingInfo.filter(
        item => item.bookingStatus === "PAST"
      );
      let pastLength = past.length;
      let totalLength = upLength + pastLength;
      return totalLength;
    },
    minutesTotal() {
      let past = this.profBookingInfo.filter(
        item => item.bookingStatus === "PAST"
      ).length;
      let minutes = past * 30;
      return minutes;
    }
    // earningsTotal() {
    // let past = this.profBookingInfo
    //   .filter(item => item.bookingStatus === "PAST")
    //   .map(item => item.bookingAmount);
    // const initialValue = 0;
    // let calculateEarnings = (accumulator, currentValue) =>
    //   accumulator + 0.8 * currentValue;
    // return past.reduce(calculateEarnings, initialValue);
    // }
  },
  methods: {
    goToProfile() {
      let professionalId;
      if ("professional" in this.userInfo) {
        professionalId = this.userInfo.professional.professionalId;
      } else {
        professionalId = this.customerToProfessionalId;
      }
      RouterUtils.changeRouteUrlTo(`/professionals/${professionalId}`);
    }
  }
};
</script>

<style scoped>
.prof-mid {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.stats-bar {
  padding: 24px 24px 24px 32px;
  border-style: solid;
  border-width: 1px;
  border-color: rgba(3, 28, 67, 0.1);
  border-radius: 10px;
  background-color: rgba(3, 28, 67, 0.03);
  margin-top: 50px;
}
.stats-grid {
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}
.centralized {
  font-family: "Galano grotesque-Medium", sans-serif;
}
.review-color {
  color: darkred;
}
</style>
